import styled from 'styled-components';

export const MpBlock = styled(`section`)`
	scroll-margin-top: 75px;
	margin-bottom: 48px;
	@media (max-width: 575px) {
		margin-bottom: 32px;
	}
`;
